import { CustomerAttributesState } from "../models/customer-attributes.model"

export const getHasSecondOffer = (casState: CustomerAttributesState) => 
    casState?.loanAcquisitionsPurl && casState?.secondLoanEligible;

export const getHasResumableApplication = (casState: CustomerAttributesState) => 
    casState?.resumePendingLoanApplicationUrl || casState?.resumeOfferedLoanApplicationUrl;